module.exports = __webpack_public_path__ + "34bc775d/img/share-action-icon.9c12578c.svg";